/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import WrapperMyAccountCreditCard from 'components/payment/mexico/claro-pagos/WrapperMyAccountCreditCard';
import LoadingBlocks from '../../forms/LoadingBlocks';
import { converter } from '../../../helpers/converter';
import { payWaySelector } from '../MyAccountSelector';
import MethodITunes from './PayWayITunes';

export class PaymentViewMode extends React.Component {
  telmexMexicoGateView() {
    return (
      <div className="row pay-way-item">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <p
              dangerouslySetInnerHTML={{
                __html: converter.convertApaUnicode(
                  this.props.translations,
                  'profile_pay_mode_title_telmex',
                  'Para tu comodidad desde aquí podrás cambiar el <b>Medio de Pago</b> seleccionado, solo si actualmente pagas con tarjeta de crédito y deseas cambiarlo a recibo Telmex/Telnor.',
                ),
              }}
            />
          </div>
        </div>
        <div id="modificar-mp-paso1" className="row">
          <form role="form">
            <div className="form-group">
              <label className="col-lg-3 col-md-4 col-sm-5 control-label">
                Con cargo a Recibo Telmex
              </label>
              <div className="col-lg-9 col-md-8 col-sm-7">
                <p className="form-control-static">
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'registro_telefono_telmex',
                    'Número Telmex',
                  )}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  plazaVipgateView(payment) {
    const creditCardCompanyStyle = { float: 'left' };
    const cardNumber = _.get(
      payment,
      ['purchase_data', 'gateway_data', 'card_number_display'],
      null,
    );
    return (
      cardNumber && (
        <div
          id="modificar-mp-paso1"
          className="row pay-way-item credit-card-item"
        >
          <div className="col-lg-10 col-md-10 col-sm-10 col-xs-12">
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                <img
                  style={creditCardCompanyStyle}
                  width="40"
                  alt="card_1"
                  src="https://www.clarovideo.com/fe/sitesplus/sk_telmex/images/tarjeta_1.png"
                />
                <img
                  style={creditCardCompanyStyle}
                  width="40"
                  alt="card_4"
                  src="https://www.clarovideo.com/fe/sitesplus/sk_telmex/images/tarjeta_4.png"
                />
              </div>
              <div className="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                <b>
                  {`${converter.convertApaUnicode(
                    this.props.translations,
                    'profile_pay_credit_card_number',
                    'Número de Tarjeta',
                  )} ${cardNumber}`}
                </b>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
            <button
              type="button"
              className="btn btn-default btn-block margin-top-05 modificar-mp"
              onClick={this.props.changeToEditMode}
            >
              {converter.convertApaUnicode(
                this.props.translations,
                'profile_button_modify',
                'Modificar',
              )}{' '}
            </button>
          </div>
        </div>
      )
    );
  }

  claropagosView() {
    const { user, payway } = this.props;
    const clienteId = _.get(user, [
      'profile',
      'paymentMethods',
      '0',
      'account',
    ]);
    return (
      <WrapperMyAccountCreditCard
        clienteId={clienteId}
        userToken={user.token}
        paywayData={payway.list}
        translations={this.props.translations}
      />
    );
  }

  getPaymentView() {
    const { payway, translations } = this.props;
    return payway.gateways.map(item => {
      switch (item) {
        case 'plazavipgate': {
          const medio = payway.groupBy[item];
          return this.plazaVipgateView(
            payway.list.find(l => l.offer_id === medio[0].offerId),
          );
        }
        case 'telmexmexicogate':
          return this.telmexMexicoGateView();
        case 'itunesgate':
          return (
            <MethodITunes
              translations={translations}
              visible={payway.itHasITunes}
            />
          );
        case 'claropagosgate':
          return this.claropagosView();
        case 'hubgate':
        default:
          return null;
      }
    });
  }

  render() {
    const { payway } = this.props;

    if (payway.list.length === 0 && payway.gateways.length === 0) {
      return <LoadingBlocks />;
    }

    return (
      <div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3>
              <strong>
                {' '}
                {converter.convertApaUnicode(
                  this.props.translations,
                  'profile_pay_mode_title',
                  'Modificar medio de pago',
                )}{' '}
              </strong>
            </h3>
          </div>
        </div>

        {this.getPaymentView()}
      </div>
    );
  }
}

PaymentViewMode.propTypes = {
  translations: PropTypes.shape({}),
  changeToEditMode: PropTypes.func,
  user: PropTypes.shape({}),
  payway: PropTypes.shape({}),
};

const mapStateToProps = state => ({
  translations: state.translations,
  metadata: state.metadata,
  user: state.user,
  config: state.config,
  payway: payWaySelector(state),
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentViewMode);
